import React from 'react'
import { Box } from '@mui/material'
import SearchLanding from './SearchLanding'
import { useSearchTokens } from '../searchDesignTokens'

const SearchLandingView = ({ mode, setMode }) => {
  const dk = useSearchTokens()

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', position: 'relative', backgroundColor: dk.surface }}>
      {/* Landing content */}
      <SearchLanding mode={mode} setMode={setMode} />
    </Box>
  )
}

export default SearchLandingView
